import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { alertActions } from '@actions';
import { bindNavigate } from '@helpers/navigation';
import PostHogManager from '@widgets/posthog-manager';

const NavigationSync = () => {
    const navigate = useNavigate();
    const { pathname, search, key } = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        bindNavigate(navigate);
        return () => bindNavigate(null);
    }, [navigate]);

    useEffect(() => {
        dispatch(alertActions.clearOtherPages(key));
        PostHogManager.capturePageView(`${pathname}${search}`);
    }, [key]);

    return null;
};

export default NavigationSync;
